// ✅ App.js — CLEAN & FIXED
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Typography } from "@mui/material";
import "./styles/Colors.css";
import AuthLayout from "./Layout/AuthLayout";
import LoginPage from "./Pages/Login/LoginPage";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import SetNewPassword from "./Pages/ForgotPassword/SetNewPassword";
import SetNewpasswordsucc from "./Pages/ForgotPassword/SetNewPasswordSucc";
import SidebarLayout from "./Layout/SidebarLayout";
import Dashboard from "./Pages/ExportJob/Dashboard/Dashboard";
import ForgotRedirect from "./Components/Route/ForgotRedirect";
import WithOutTokenRedirect from "./Components/Route/WithOutTokenRedirect";
import WithTokenRedirect from "./Components/Route/WithTokenRedirect";
import { navurl } from "./Config/Routeconfig/NavigationUrl";
import { apiurl } from "./Config/ApiConfig/ApiUrl";
import CreateNewCustomer from "./Pages/ExportJob/CreateNewCustomer/CreateNewCustomers";
import CreateNewJob from "./Pages/ExportJob/CreateNewJob/CreateNewJob";
import ImportCreateNewJob from "./Pages/ImportJob/CreateNewJob/CreateNewJob";
import ImportDashboard from "./Pages/ImportJob/Dashboard/ImportDashboard";
import ImportCreateNewCustomer from "./Pages/ImportJob/CreateNewCustomer/CreateNewCustomer";
import SessionDialog from "./SessionDialog";
import OrganizationDashboard from "./Pages/CreateNewCustomer/Dashboard/Dashboard";

function App() {
  return (
    <>
      <SessionDialog />
      <Routes>
        {/* ================= AUTH ROUTES ================= */}
        <Route path="/" element={<AuthLayout />}>
          <Route
            path={navurl.Login}
            element={
              <WithTokenRedirect>
                <LoginPage />
              </WithTokenRedirect>
            }
          />
          <Route
            path={navurl.ForgotPassword}
            element={
              <ForgotRedirect>
                <ForgotPassword />
              </ForgotRedirect>
            }
          />
          <Route path={navurl.ResetPassword} element={<SetNewPassword />} />
          <Route path="password-success" element={<SetNewpasswordsucc />} />
          <Route index element={<Navigate to={navurl.Login} replace />} />
        </Route>

        {/* ================= EXPORT ROUTES ================= */}
        <Route
          path="export"
          element={
            <WithOutTokenRedirect>
              <SidebarLayout />
            </WithOutTokenRedirect>
          }
        >
          <Route index element={<Dashboard />} />

          <Route
            path={apiurl.Exportdashboard_CreateJob + "/:exporterId?"}
            element={<CreateNewJob />}
          />

          {/* <Route path="create-customer" element={<CreateNewCustomer />} /> */}
        </Route>

        {/* ================= IMPORT ROUTES ================= */}
        <Route
          path="import"
          element={
            <WithOutTokenRedirect>
              <SidebarLayout />
            </WithOutTokenRedirect>
          }
        >
          <Route index element={<ImportDashboard />} />

          <Route
            path={apiurl.Importdashboard_CreateJob + "/:importerId?"}
            element={<ImportCreateNewJob />}
          />

          {/* <Route path="create-customer" element={<ImportCreateNewCustomer />} /> */}
        </Route>

        {/* ================= ORGANIZATION ROUTES ================= */}
        <Route
  path="organization"
  element={
    <WithOutTokenRedirect>
      <SidebarLayout />
    </WithOutTokenRedirect>
  }
>
  {/* Dashboard */}
  <Route index element={<OrganizationDashboard />} />

  {/* Create + Edit (Optional ID) */}
  <Route
    path="create-customer/:customerId?"
    element={<CreateNewCustomer />}
  />
</Route>


        {/* ================= FALLBACK ================= */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

export default App;
